import React from "react";

import { useSearchParams, Link } from "react-router-dom";

import { api, formatApiError } from "@/lib/api";

import { ShieldCheck, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();

  const token = params.get("token");

  const [loading, setLoading] = React.useState(true);

  const [success, setSuccess] = React.useState(false);

  const [error, setError] = React.useState("");

  React.useEffect(() => {
    const verify = async () => {
      if (!token) {
        setError("Missing verification token");

        setLoading(false);

        return;
      }

      try {
        await api.get(`/auth/verify-email?token=${token}`);

        setSuccess(true);
      } catch (e) {
        setError(formatApiError(e));
      } finally {
        setLoading(false);
      }
    };

    verify();
  }, [token]);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center px-4">
      <div className="w-full max-w-md rounded-3xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-xl overflow-hidden">
        {/* HEADER */}

        <div className="bg-gradient-to-r from-emerald-500 to-blue-600 p-8 text-white text-center">
          <h1 className="font-display text-3xl font-bold">AccessWealth</h1>

          <p className="mt-2 text-sm text-white/80">Email Verification</p>
        </div>

        {/* BODY */}

        <div className="p-8 text-center">
          {loading ? (
            <>
              <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-slate-100 dark:bg-slate-800">
                <Loader2 className="h-10 w-10 animate-spin text-emerald-600" />
              </div>

              <h2 className="mt-6 text-2xl font-bold text-slate-900 dark:text-white">
                Verifying...
              </h2>

              <p className="mt-2 text-sm text-slate-500">
                Please wait while we verify your email.
              </p>
            </>
          ) : success ? (
            <>
              <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-emerald-100 dark:bg-emerald-500/10">
                <ShieldCheck className="h-10 w-10 text-emerald-600" />
              </div>

              <h2 className="mt-6 text-2xl font-bold text-slate-900 dark:text-white">
                Email Verified 🎉
              </h2>

              <p className="mt-2 text-sm text-slate-500">
                Your account has been verified successfully.
              </p>

              <Link
                to="/login"
                className="btn-primary mt-8 inline-flex w-full justify-center"
              >
                Continue to Login
              </Link>
            </>
          ) : (
            <>
              <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-rose-100 dark:bg-rose-500/10">
                <XCircle className="h-10 w-10 text-rose-600" />
              </div>

              <h2 className="mt-6 text-2xl font-bold text-slate-900 dark:text-white">
                Verification Failed
              </h2>

              <p className="mt-2 text-sm text-slate-500">{error}</p>

              <Link
                to="/login"
                className="btn-secondary mt-8 inline-flex w-full justify-center"
              >
                Back to Login
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
